import React from 'react';
import type { FloatingAction } from './types';

export interface FloatingBottomBarProps {
  actions: FloatingAction[];
}

/**
 * Bottom-anchored action bar for BombiixAGGrid (reset / save / download style
 * clusters). Buttons use the master-design `.bombiix-icon-container` treatment
 * so glyph size and hover match every other icon button in the app.
 */
const FloatingBottomBar: React.FC<FloatingBottomBarProps> = ({ actions }) => {
  if (!actions?.length) {
    return null;
  }
  return (
    <div className="cag-floating-bar">
      {actions.map((action, index) =>
        action.divider ? (
          <div key={`divider-${index}`} className="cag-floating-bar__divider" />
        ) : (
          <button
            key={action.label ?? `action-${index}`}
            type="button"
            className="bombiix-icon-container cag-floating-bar__btn"
            title={action.label}
            aria-label={action.label}
            onClick={action.onClick}
            disabled={action.disabled}
          >
            {action.icon && <i className={action.icon} />}
            {action.content}
          </button>
        ),
      )}
    </div>
  );
};

export default FloatingBottomBar;
